<div class="checkbox" [class.disabled]="disabled()" (click)="toggleValue()">
  <ion-icon [name]="checked() ? 'checkbox' : 'square-outline'" />
  @if (label()) {
    <div>{{ label() }}</div>
  }
</div>